import { passCodes } from '../passCodes';
import { zdarCustomCiphers } from '../zdarEscapeGameCustomCiphers';
import track16 from '../../../../assets/audio/tracks/track16.mp3';

const hints = [
    {
        text: 'Najděte písmeno, které vyhovuje všem zadaným podmínkám. Buďte pozorní!',
    },
    {
        text: 'Poslední písmeno je Y a jde o geometrický tvar.',
    },
    {
        text: 'Kódem jsou: kužely',
        solution: true,
    },
];
export const step16cones = {
    id: 15,
    title: '7. stanoviště',
    taskText: `
        <p>
            Hehe, to je sranda. Mně šlo jen o to zkusit, jak ti jdou barvy. Já se v nich totiž moc nevyznám. Teď ale ten opravdový úkol, ne? 
        </p>
    `,
    catImage: 6,
    audio: track16,
    snowAudio: track16,
    cipher: {
        label: 'Úkol',
        custom: zdarCustomCiphers.cones,
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[10],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
